type OwnedData = {
  comment?: string;
  commentAt?: Date | string;
};

type LatestComment = {
  comment: string;
  commentAt: Date | string;
  source: "payer" | "payee";
};

export function getLatestWorkItemComment(
  payerOwnedData: OwnedData | undefined,
  payeeOwnedData: OwnedData | undefined
): LatestComment | null {
  const payerEntry =
    payerOwnedData?.comment && payerOwnedData.commentAt
      ? {
          comment: payerOwnedData.comment,
          commentAt: payerOwnedData.commentAt,
          source: "payer" as const
        }
      : null;

  const payeeEntry =
    payeeOwnedData?.comment && payeeOwnedData.commentAt
      ? {
          comment: payeeOwnedData.comment,
          commentAt: payeeOwnedData.commentAt,
          source: "payee" as const
        }
      : null;

  if (!payerEntry && !payeeEntry) return null;
  if (!payerEntry) return payeeEntry;
  if (!payeeEntry) return payerEntry;

  return new Date(payerEntry.commentAt).getTime() >=
    new Date(payeeEntry.commentAt).getTime()
    ? payerEntry
    : payeeEntry;
}
